mainApp.directive('entityEditor', function () {
	return {
		templateUrl: '/public/directives/editor.html',
		restrict : "E",
		scope : {
			entity: "=",
			errors: "=",
			rt: "@"
		},
		controller:  ['$scope', 'GeneralUtilsService', 'TimeZoneService', function($scope, GeneralUtilsService, TimeZoneService) {
			$scope.timezones = [];

            TimeZoneService.getTimeZones(function(timeZones) {
                $scope.timezones = timeZones;
            });

		    $scope.entityConfigs = {
			    "SITE":{
			        tables:{"subnetsConfig":{"datamodifed":false,id:"subnetTable",url:"/subnets?siteId=",
						"fields":
							[
								{"label":"Name","path":"name","template":"<span><input type='text' class='form-control' ng-model='item.name' /></span>"},
								{"label":"IP","path":"subnet","template":"<span><input type='text' class='form-control' ng-model='item.subnet' /></span>"},
								{"label":"Network","path":"interfaceName","template":"<span>{{item.interfaceName}}</span>"}
		            ]
					}}
			    },
			    "ACCESSLOGIN":{},
                "ACCOUNT":{}
			};
			$scope.tables = {};
            function setShowItem(){
                $scope.showItem = 'general';
            }

			$scope.gredatamodified = false;

   			function setAllowGreTunnel(){
   				if($scope.entity.greRange && $scope.entity.greRange.length > 0){
            		$scope.entity.allowGreTunnel = true;
            	}
   			}

            setShowItem();

		    $scope.$watch('entity.uniqueIdentifier', function(newValue, oldValue) {
		        if(!$scope.entity || Object.keys($scope.entity).length === 0) return;
		        $scope.orig = angular.copy($scope.entity);
		        $scope.entityType = $scope.entity.type.toLowerCase();
		        for(var name in $scope.entityConfigs[$scope.entity.type].tables){
		           var table = $scope.tables[name];
		           table.datamodifed = true;
		        }
		        $scope.gredatamodified = new Date().getTime();
                setShowItem();
                setAllowGreTunnel();
			});


			$scope.$root.hasChanges = function(){
		        return true;
		    };
		    
		    //fields that should be edited for each type
		    var editFields = {
		        "account":["description","creationDate","workingHours","timezone"],
		        "site":["description","address","workingHours","overideWorkinghours","greRange", "pw","hosts","interfaces", "dnsPrimaryRange", "dnsSecondaryRange"],
		        "login":["firstName","lastName","email"],
				"accesslogin":["firstName","lastName","email"]
		    };
		    
		    
		    $scope.edit = function(){
		        var queryParams = {'save':true};
		        queryParams[$scope.entityType + "Id"] = $scope.entity.id;
		        queryParams["fields"] = angular.toJson(editFields[$scope.entityType]);
			    $scope.entity.newSaveMethod = true;
			    
			    if($scope.entity.hosts){
			        $scope.entity.hosts = $scope.tables["subnetsConfig"].items;
			    }
//			    if(!$scope.entity.allowGreTunnel && $scope.entity.greRange && $scope.entity.greRange.subnet){
//					$scope.entity.greRange.subnet = "";
//                }
				store.save({
					path: "/edit",
					data: $scope.entity,
					dataObj: 'json',
					queryParams: queryParams,
					success: function(data) {
						$scope.$root.handleServerResponse(data, $scope.entityType , $scope.entityType + ' saved successfully');
						if(data.status !== "ERROR"){
							$scope.entity = data.model;
							setAllowGreTunnel();
							$scope.orig = angular.copy($scope.entity);
						}
					}
			    });
   			 };


   			$scope.toggleWorkinghours = function(){
   			    if($scope.entity.overideWorkinghours == null){
   			       $scope.entity.overideWorkinghours = true;
   			    }
   			    else {
   			       $scope.entity.overideWorkinghours = !$scope.entity.overideWorkinghours;
   			    }
   			};
   			 
		    
		    $scope.dataConfig = {
				rt: $scope.rt,
		        tableConfig:null,
		        dataURL : function(){
		            if(!$scope.entity || Object.keys($scope.entity).length === 0  || $scope.entity.id < 0 ){
		                return null;
		            }
		            else {
		            	return this.tableConfig.url + $scope.entity.id;
		            }
		        },
		        getData : function() {
		           if(!$scope.entity || Object.keys($scope.entity).length === 0  || $scope.entity.id < 0){
		                return {"items":[]};
		           }
		           return null;
		        },
		        processData : function(items){
		           this.origItems = angular.copy(items);
		        },
		        showTable: false,
		        type : "Subnet",
		        actions: [],
		        selectedItems:[],
		        pageSize:10,
		        defer:true,
		        customButtons : [
		         {'name':'add','text':'New','func' : 
			         function(selectedItems,config) {
			            config.items.push({id:GeneralUtilsService.getRandomId(),"name":"","subnetType":'Department'});
			         }
		         },
		         {'name':'remove','text':'Delete','func' : 
			         function(selectedItems,config) {
				            selectedItems.forEach(function(selectedItem) {
					                for(var i = 0 ; i < config.items.length ; i++){
					                    var item = config.items[i];
					                    if(item.id === selectedItem.id){
						                       config.items.splice(i,1);
						                       break;
					                    }
					                }  
				            });
				    }
				 }
		       ],
		       noSearch:true
		    };

			$scope.greConfig = {
				dataURL : function(){
					return null;
				},
				parseData : function() {
					if ($scope.entity) {
						return $scope.entity.greRange;
					} else {
						return [];
					}
				},
				fields :  [
				  {"label":"Source IP","path":"subnet","template":"<span><input type='text' class='form-control' ng-model='item.subnet' /></span>"}
				 ],
				actions : [],
				addAction : function(){
					$scope.entity.greRange.push({id:GeneralUtilsService.getRandomId(), name: "gre"});
				},
				specialActions : [
					{"func":function(selectedItems) {
						 selectedItems.forEach(function(item) {
									for(var i = 0 ; i < $scope.entity.greRange.length ; i++){
										var subnet = $scope.entity.greRange[i];
										if(subnet.id === item.id){
											   $scope.entity.greRange.splice(i,1);
											   break;
										}
									}
							});
					},"icon":"remove",tooltip:"Delete"}
				],
				type : "GreSubnet",
				selectedItems:[],
				pageSize:10,
				sortList : [],
				noSearch:true
			};
		    
		    for(var type in $scope.entityConfigs){
		        var entityConfig = $scope.entityConfigs[type];
		        for(var name in entityConfig.tables){
		           var table = angular.extend({}, $scope.dataConfig); 
		           table.tableConfig = entityConfig.tables[name];
				   table.fields = table.tableConfig.fields;
				   $scope.tables[name] = table;
		        }
		         
		    }

		}]
	};
	
});